import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import Header from './components/Header';
import BooksGrid from './components/BooksGrid';
import BookPreview from './components/BookPreview';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        {/* <Header /> */}
        <Routes>
          <Route path="/" element={<BooksGrid />} />
          <Route path="/preview/:bookId" element={<BookPreview />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App; 